export enum DeviceInputType {
  MOBILE_APP = 'MOBILE_APP',
  API_INTEGRATION = 'API_INTEGRATION',
  FILE_IMPORT = 'FILE_IMPORT',
  IOT_DEVICE = 'IOT_DEVICE',
  MANUAL = 'MANUAL',
  COMPUTED = 'COMPUTED',
  SURVEY = 'SURVEY',
  UNKNOWN = 'UNKNOWN',
}
